<template>
  <div id="login">
    <div class="login-page">
      <div v-if="errors.length>0">
        <ul id="errors" :class="[isActive ? successClass : dangerClass ]">
          <li v-for="error in errors" :key="error">{{error[0]}}</li>
        </ul>
      </div>
      <h1
        style="font-size: 16px;margin: 0px;padding: 10px;color: #0056b3;"
      >{{$t('message.lost_pass')}}</h1>
      <div class="form" id="forgottForm">
        <img src="../../assets/logo.png" style="width: 225px;margin: 0px 0px 20px 0px;">

        <div>
          <form id="forgottForm" class="login-form" @submit="forgottPass" method="post">
            <input v-model="user.email" type="text" name="email" :placeholder="$t('message.email')">
            <p>* - {{$t('message.required')}}</p>
            <button>{{$t('message.send')}}</button>
            <!--<div style="font-size: 14px;color: red;margin-top: 10px;">
              został wysłany mail
              <br>z potwierdzeniem zmiany hasła
            </div>
            -->
            <!--<input type="submit" class="btn btn-primary" value="Zaloguj">-->
            <p class="message">
              <router-link to="/login" class="btn btn-link">{{$t('message.anuluj')}}</router-link>
            </p>
          </form>
        </div>
        <!--
        <div v-if="!isSendMail">
          <form id="changeForm" class="login-form" @submit="changePass" method="post">
            <input v-model="user.email" type="mail" name="email" placeholder="e-Mail">
            <input v-model="user.password" type="password" name="password" placeholder="Nowe hasło">
            <input
              v-model="user.confirm_password"
              type="password"
              name="confirm_password"
              placeholder="Powtórz nowe hasło"
            >
        <button>Zmień</button>-->
        <!--
            <span
              style="font-size: 12px; margin: 10px 0px; padding: 0px; line-height: 15px; display: block;"
            >
              wprowadzenie nowego hasła będzie możliwe
              <br>po akceptacji linku, który został wysłany na maila
            </span>
        -->
        <!--<input type="submit" class="btn btn-primary" value="Zaloguj">-->
        <!--
            <p class="message">
              <router-link to="/login" class="btn btn-link">Pomiń</router-link>
            </p>
          </form>
        </div>-->
      </div>
    </div>
  </div>
</template>

<script>
import router from "../../router";
import axios from "axios";

export default {
  name: "Remember",
  data() {
    return {
      user: {
        email: null
      },
      errors: [],
      isActive: false,
      successClass: "alert alert-success",
      dangerClass: "alert alert-danger"
    };
  },
  components: {},
  computed: {},
  methods: {
    forgottPass: function(e) {
      e.preventDefault();

      //this.isSendMail = false;
      const self = this;
      let lang = this.$i18n.locale;
      let trans = this.$i18n.messages[lang].message;

      axios
        .post(process.env.VUE_APP_ROOT_API + "auth/password/create", {
          email: this.user.email,
          lang: lang
        })
        .then(function(response) {
          //console.log(response);
          console.log("Remember - validacja");
          self.isActive = true;
          //console.log(response);

          self.errors = [];
          for (let err of Object.values(response.data)) {
            //self.errors.push += err + " ";
            self.errors.push(err);
          }
          //console.log(self.errors);
          //for (let err of Object.values(response.errors)) {
          //self.errors.push += err + " ";
          //  console.log('asadsa: '+err.email);
          //self.errors.push(err);
          //}
          //this.isSendMail = true;
          //self.errors = [];
          //for (let err of Object.values(response.errors)) {
          //self.errors.push += err + " ";
          //  self.errors.push(err);
          //}
          //console.log(self.errors);
          //if (response.data.message != "") {
          //  alert(trans.send_mail);
          //}
        })
        .catch(function(error) {
          console.log(error);
          //alert(error);
        });
    }
    /*
    changePass: function(e) {
      e.preventDefault();

      axios
        .get(`http://localhost:8081/auth/password/check/${this.user.email}`)
        .then(function(response) {
          console.log(response);

          if (response.data.token) {
            console.log("logowanie zakończone sukcesem");
            //sessionStorage.setItem("log_user", JSON.stringify(response.data));
            //this.log_user = false;
            //$router.push({ path: "/" });
            let tok = response.data.token;

            axios
              .post("http://127.0.0.1:8081/auth/reset", {
                email: this.user.email,
                password: this.user.password,
                password_confirmation: this.user.confirm_password,
                token: tok
              })
              .then(function(response) {
                console.log(response);
    */
    /*
                if (response_reset.data.token) {
                  console.log("logowanie zakończone sukcesem");
                  //sessionStorage.setItem("log_user", JSON.stringify(response.data));
                  //this.log_user = false;
                  //$router.push({ path: "/" });
                } else if (response.data.status == false) {
                  console.log("błędne dane");
                  alert("Login incorrect");
                } else {
                  console.log("validacja");
                  let errors = "";
                  for (let err of Object.values(response.data)) {
                    errors += err + " ";
                  }
                  alert(errors);
                }
                */
    /*
              })
              .catch(function(error) {
                console.log(error);
                alert("Problem z połączeniem.");
              });

            //koniec axios
            //----------------------------
          } else if (response.data.status == false) {
            console.log("błędne dane");
            alert("Login incorrect");
          } else {
            console.log("validacja");
            let errors = "";
            for (let err of Object.values(response.data)) {
              errors += err + " ";
            }
            alert(errors);
          }
        })
        .catch(function(error) {
          console.log(error);
          alert("Problem z połączeniem.");
        });
    }
    */
  },
  mounted() {}
};
</script>


<style scoped>
/*
#login {
  width: 500px;
  margin: 0 auto;
  padding: 23px;
  background: #ddd;
  border-radius: 10px;
  box-shadow: 5px 5px;
}
*/
@import url(https://fonts.googleapis.com/css?family=Roboto:300);

div.form p {
  font-size: 14px;
  text-align: left;
  color: #999;
}

#errors {
  font-size: 14px;
  list-style: disclosure-closed;
  list-style-position: outside;
  list-style-position: outside;
  margin: 0px auto;
  padding: 10px;
  list-style-position: inside;
  width: 360px;
}
#errors li {
  padding: 0px;
}

.login-page {
  width: 360px;
  padding: 0px;
  margin: auto;
}
.form {
  position: relative;
  z-index: 1;
  background: #ffffff;
  max-width: 360px;
  margin: 0 auto 100px;
  padding: 45px;
  text-align: center;
  box-shadow: 0 0 20px 0 rgba(0, 0, 0, 0.2), 0 5px 5px 0 rgba(0, 0, 0, 0.24);
}
.form input {
  font-family: "Roboto", sans-serif;
  outline: 0;
  background: #f2f2f2;
  width: 100%;
  border: 0;
  margin: 0 0 8px;
  padding: 8px;
  box-sizing: border-box;
  font-size: 14px;
}
.form button {
  font-family: "Roboto", sans-serif;
  text-transform: uppercase;
  outline: 0;
  background: #23497f;
  width: 100%;
  border: 0;
  padding: 8px;
  color: #ffffff;
  font-size: 14px;
  -webkit-transition: all 0.3 ease;
  transition: all 0.3 ease;
  cursor: pointer;
}
.form button:hover,
.form button:active,
.form button:focus {
  background: #0056b3;
}
.form .message {
  margin: 15px 0 0;
  color: #b3b3b3;
  font-size: 12px;
}
.form .message a {
  color: #23497f;
  text-decoration: none;
  float: left;
  font-size: 14px;
}
.form .message a:hover {
  color: #0056b3;
}
.form .register-form {
  display: none;
}
.container {
  position: relative;
  z-index: 1;
  max-width: 300px;
  margin: 0 auto;
}
.container:before,
.container:after {
  content: "";
  display: block;
  clear: both;
}
.container .info {
  margin: 50px auto;
  text-align: center;
}
.container .info h1 {
  margin: 0 0 15px;
  padding: 0;
  font-size: 36px;
  font-weight: 300;
  color: #1a1a1a;
}
.container .info span {
  color: #4d4d4d;
  font-size: 12px;
}
.container .info span a {
  color: #000000;
  text-decoration: none;
}
.container .info span .fa {
  color: #ef3b3a;
}
</style>



// WEBPACK FOOTER //
// src/components/Auth/Remember.vue